/* eslint-disable class-methods-use-this */
import { SumInsuredDto } from '../dtos/sum-insured-dto';
import SumInsured from '../models/sum-insured';

export default class SumInsuredMapping {
  getSumInsuredResponse(data: SumInsuredDto): SumInsured {
    return {
      estimated: data.estimado,
      max: data.maximo,
      min: data.minimo,
      selected: data.seleccionado,
      estimatedSoles: data.estimadoSoles,
      maxSoles: data.maximoSoles,
      minSoles: data.minimoSoles,
      selectedSoles: data.seleccionadoSoles,
      exchangeRate: data.tipoCambio,
    };
  }
}
